import React, { useRef, useState } from 'react'
import { CRMWorkflow, CRMWorkflowTemplate, RedtailWorkflowTemplate, WealthboxWorkflowTemplate } from '../../../../../../models/Integration'
import { User } from '../../../../../../models/User'
import { Button } from '../../../../../../components/Button/Button'
import { StartWealthboxWorkflowOverlay } from './wealthbox/StartWealthboxWorkflowOverlay'
import { StartRedtailWorkflowOverlay } from './redtail/StartRedtailWorkflowOverlay'

export const CRMWorkflowTemplateView: React.FC<{
  workflowTemplate: CRMWorkflowTemplate
  contact: User
  serviceId: string
  onWorkflowStarted?: (workflow: CRMWorkflow) => void
  suggestedLabel?: string
}> = ({ workflowTemplate, contact, serviceId, onWorkflowStarted, suggestedLabel }) => {
  const [show, setShow] = useState(false)
  const target = useRef(null)

  const handleWorkflowStarted = (workflow: CRMWorkflow) => {
    setShow(false)
    onWorkflowStarted && onWorkflowStarted(workflow)
  }
  return (
    <div className='d-flex gap-4 align-items-center border-default zocks-border-0.25 p-3'>
      <div className='d-flex flex-column gap-1'>
        <div className='d-flex gap-1'>
          <div className='bold'>{workflowTemplate.name}</div>
        </div>
        <div className='d-flex gap-1 paragraph-extra-small'>
          {serviceId === 'wealthbox' ? <div>{(workflowTemplate as WealthboxWorkflowTemplate).description}</div> : null}
        </div>
      </div>
      <div className='d-flex ms-auto justify-content-center align-items-center'>
        <Button ref={target} variant='borderless' className='button-small' onClick={() => setShow(true)}>
          <i className='bi bi-play-btn' />
          <span className='text-decoration-underline'>Start this workflow</span>
        </Button>
        {show ? (
          serviceId === 'wealthbox' ? (
            <StartWealthboxWorkflowOverlay
              targetRef={target}
              show={show}
              workflowTemplate={workflowTemplate as WealthboxWorkflowTemplate}
              serviceId={serviceId}
              onWorkflowStarted={handleWorkflowStarted}
              contact={contact}
              onHide={() => setShow(false)}
              suggestedLabel={suggestedLabel}
            />
          ) : serviceId === 'redtail' ? (
            <StartRedtailWorkflowOverlay
              targetRef={target}
              show={show}
              workflowTemplate={workflowTemplate as RedtailWorkflowTemplate}
              serviceId={serviceId}
              onWorkflowStarted={handleWorkflowStarted}
              contact={contact}
              onHide={() => setShow(false)}
              suggestedLabel={suggestedLabel}
            />
          ) : null
        ) : null}
      </div>
    </div>
  )
}
